import {GlobalConstants} from "../data/GlobalConstants";
import {handleResponse} from "../util/functions";
import {getToken} from "../helpers/helperJWT";
import {loaderService} from "./loaderService";

const url = GlobalConstants.urlApi;

export const vendedorServices = {
    getSolicitudesVendedores,
    setVendedor
}

function getSolicitudesVendedores(){
    loaderService.showLoader({label: 'Cargando...'});

    const requestOptions = {
        method: 'POST',
        headers:{
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({})
    }

    return fetch(`${url}/vendedores/getSolicitudesVendedores`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
}

function setVendedor(data, idTercero){
    loaderService.showLoader({label: 'Cargando...'})

    const requestOptions = {
        method: 'POST',
        headers:{
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({data: data, idTercero: idTercero})
    }

    return fetch(`${url}/vendedores/setVendedor`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
}